import { MjmlColumn, MjmlSection, MjmlText } from "@faire/mjml-react";
import { Section, SharedProps } from "@redotech/redo-model/email-builder";
import { memo } from "react";

export type DiscountState = Section.Discount & SharedProps;

export const EmailDiscount = memo(function EmailDiscount(
  props: DiscountState & { discountCode?: string },
) {
  const padding = props.sectionPadding;

  return (
    <MjmlSection
      backgroundColor={props.sectionColor}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
    >
      <MjmlColumn backgroundColor={props.blockBackgroundColor}>
        <MjmlText
          align={props.alignment}
          color={props.textColor}
          fontFamily={props.fontFamily}
          fontSize={props.fontSize}
          fontWeight={props.fontWeight}
          padding="8px"
        >
          {!props.isBuilder ? props.discountCode : "XXXXXX"}
        </MjmlText>
      </MjmlColumn>
    </MjmlSection>
  );
});
